export const getIdFromUrl = (url, level) => {
    if(level){
        return url.split("/")[level]
    }
    return url.split("/")[2]
}
